import {Box} from '@mui/material';
import './ProtocolIntelligenceContent.scss';
import UploadProtocol from './uploadProtocol/UploadProtocol';
import GenerateArtifacts from './generateArtifacts/GenerateArtifacts';
import {useReviewHeaderContext} from '../../header/ReviewHeader';
import ArrTextField from '../../../../common/arr-text-field/ArrTextField';

const ProtocolIntelligenceContent = () => {
  const {
    protocolVersions = [],
    searchTerm,
    setSearchTerm,
    refetchProtocolList,
  } = useReviewHeaderContext();

  return (
    <>
      {protocolVersions.length > 0 || searchTerm.length > 0 ? (
        <Box className="protocol-intelligence-content">
          <ArrTextField
            placeholder="Search"
            sizeVariant="medium"
            type="search"
            dataTestId="protocol-search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && searchTerm.length > 2) {
                refetchProtocolList();
              }
            }}
            className="search-in-artifacts"
          />
          <Box className="artifact-list">
            {protocolVersions.map((record) => (
              <GenerateArtifacts key={record.protocolId} protocol={record} />
            ))}
          </Box>
        </Box>
      ) : (
        <UploadProtocol />
      )}
    </>
  );
};

export default ProtocolIntelligenceContent;
